import React, { useEffect } from "react";
import { getGoogleAuthLoginURL } from "../Helpers/backendHelper";
import { ReactComponent as AriaiLogo } from "../images/svg/icons/ariai_logo.svg";
import { ReactComponent as GoogleIcon } from "../images/svg/icons/google.svg";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../Helpers/utils";
import { AxiosResponse } from "axios";
import { JumpInResponse } from "../Helpers/backendResponseInterfaces";

const defaultDelay = 1000;
const defaultDuration = 2000;

interface LoginOption {
  provider: string;
  getAuthURL: string;
  icon: JSX.Element;
}

const loginOptions: LoginOption[] = [
  {
    provider: "Google",
    getAuthURL: "google",
    icon: <GoogleIcon />,
  },
];

const SingleLine: React.FC = () => (
  <div className="flex-grow">
    <div className="h-px bg-gray-500 flex-none order-2 flex-grow"></div>
  </div>
);

interface JumpInButtonProps {
  provider: string;
  getAuthURL: string;
  icon: JSX.Element;
}

const JumpInButton: React.FC<JumpInButtonProps> = ({ provider, getAuthURL, icon }) => {
  const { mutate } = useMutation({
    mutationFn: getGoogleAuthLoginURL,
    onSuccess: (data: AxiosResponse<JumpInResponse>) => {
      window.location.href = data.data.url;
    },
  });

  const handleOnClick = () => {
    mutate(getAuthURL);
  };

  return (
    <div
      onClick={handleOnClick}
      className="h-10 w-full bg-slate-100 hover:bg-white hover:border transition-all duration-300 rounded-lg flex flex-row items-center justify-center px-4 cursor-pointer"
    >
      <div className="flex-shrink-0">{icon}</div>
      <div className="flex-grow text-center">{provider}</div>
    </div>
  );
};

export const Register: React.FC = () => {
  const navigate = useNavigate();
  const user = getUserData();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const companyTitleSection = document.querySelector(".company-title-section");
      const registerLoginSection = document.querySelector(".register-login-section");
      if (companyTitleSection) {
        companyTitleSection.classList.remove("-translate-y-full", "basis-full");
        companyTitleSection.classList.add("basis-4/12");
      }
      if (registerLoginSection) {
        registerLoginSection.classList.add("opacity-100");
      }
    }, defaultDelay);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex justify-center basis-2 md:basis-full">
      <div className="flex flex-col items-end h-screen">
        <div
          className={`cursor-default company-title-section flex flex-col justify-end items-end basis-full transition-all duration-${defaultDuration} delay-${defaultDelay} transform -translate-y-full`}
        >
          <div className="flex">
            <AriaiLogo />
            <div className="font-inter font-bold text-6xl leading-none text-center tracking-tighter">
              Traders Forum
            </div>
          </div>
          <div className="font-inter font-bold text-sm text-center text-gray-400 leading-none tracking-tighter">
            powered by Anthill Funds
          </div>
        </div>
        <div
          className={`register-login-section flex flex-col basis-5/12 items-center justify-center gap-6 w-full opacity-0 transition-opacity duration-${defaultDuration} delay-${defaultDelay}`}
        >
          <div className="font-inter font-semibold text-2xl">Jump In!</div>
          <div className="flex flex-row justify-center items-center gap-2 w-full">
            <SingleLine />
            <div className="text-base text-gray-500">continue with</div>
            <SingleLine />
          </div>
          {loginOptions.map((option) => (
            <JumpInButton key={option.provider} {...option} />
          ))}
        </div>
      </div>
    </div>
  );
};